var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93942 12.6465L7.69217 11.8975L7.69217 11.8975L7.69216 11.8975C5.33896 11.1131 4.16235 10.7209 4.16235 10.0001C4.16235 9.27934 5.33896 8.88713 7.69218 8.10273L16.2053 5.26501C17.8611 4.71308 18.689 4.43711 19.126 4.87413C19.5631 5.31114 19.2871 6.13904 18.7352 7.79483L15.8974 16.308L15.8974 16.308C15.113 18.6612 14.7208 19.8378 14.0001 19.8378C13.2793 19.8378 12.8871 18.6612 12.1027 16.308L11.3536 14.0608L15.7072 9.7072C16.0977 9.31668 16.0977 8.68351 15.7072 8.29299C15.3167 7.90247 14.6835 7.90247 14.293 8.29299L9.93942 12.6465Z",
    fill: "#FF2241"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationType);
export default __webpack_public_path__ + "static/media/location__type.db1d2ade3ae0375058f1a7b700b907b7.svg";
export { ForwardRef as ReactComponent };